// This is an event details page which has its own route

import axios from "axios";
import { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

export const Event = () => {

  const [event , setEvent ] = useState({})

  const {id} = useParams();

  useEffect(()=>{

    axios.get(`http://localhost:8080/meetups/${id}`).then(({data})=>{
      setEvent(data)
    })

  },[]);


  return (
    <div className="eventContainer">
      {/* add your children here (divs)
      ex : title, theme, description, date, time, location, image(optional)
      the classNames should be also : title, theme, description, date, time, location, image(optional)
      */}

      {/* only one of the buttons should be visible depending on the status of subcription
      Hint : use conditional rendering */}

      <div>Title :  {event.title}  </div>
      <div> Theme :   {event.theme} </div>
      <div> Description :  {event.description}  </div>
      <div> Date :  {event.date} </div>
      <div> Tiem :   {event.time} </div>
      <div> Location :  {event.location} </div>
      <div> Image :  {event.image} </div>

      <button className="unsubscribe" onClick={()=> {} } >Unsubscribe</button>
      <button className="subscribe" onClick={() => { }}>Subscribe</button>
    </div>
  );
};
